import React, { Component, useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'
import WTypography from '../../../../Components/whiteTypography'

const optionsbar = {
  indexAxis: 'y',
  aspectRatio: 1.8,

  elements: {
    bar: {
      borderWidth: 1,
    },
  },
  scales: {
    x: {
      stacked: true,
      ticks: {
        color: 'white',
      },
      grid: {
        color: 'rgba(255,255,255,0.1)',
      },
    },
    y: {
      stacked: true,
      ticks: {
        color: 'white',
        display: false,
      },
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: true,
      labels: {
        color: 'white',
      },
    },

    datalabels: {
      color: 'white',
      formatter: (val, ctx) => ctx.chart.data.labels[ctx.dataIndex],
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.yLabel
        },
      },
    },
  },
}

function HorizentalBarChart({ reports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [data, setRevData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
      },
    ],
  })
  useEffect(() => {
    let labels = ['', '']
    let data1 = []
    let data2 = []
    let data3 = []

    // reports && labels.push('Moyenne national')
    // reports && labels.push('Emission total')
    // reports && labels.push('Emission')

    reports.length > 0 && data1.push(reports[0].emission_moyen)
    reports.length > 0 && data2.push('')
    reports.length > 0 &&
      data2.push(
        reports[0].emission_total -
          (reports[0].emission_total -
            (reports[0].emission_total -
              (reports[0].emission_total * reports[0].pourcentage) / 100)),
      )
    reports.length > 0 && data3.push('')
    reports.length > 0 &&
      data3.push(
        reports[0].emission_total -
          (reports[0].emission_total - (reports[0].emission_total * reports[0].pourcentage) / 100),
      )
    // reports.length > 0 &&
    //   data.push(
    //     reports[0].emission_total - (reports[0].emission_total * reports[0].pourcentage) / 100,
    //   )
    // }

    reports &&
      setRevData({
        labels: labels,
        datasets: [
          {
            data: data1,
            label: t('dashboard.chartLegend.nationalAverage') /* LAP-733 (GE022) */,
            backgroundColor: ['#93b7ff'],
            borderColor: ['#93b7ff'],
            borderWidth: 1,
            hoverOffset: 4,
            barThickness: 30,
          },
          {
            data: data2,
            label: t('dashboard.chartLegend.totalEmission') /* LAP-733 (GE022) */,
            backgroundColor: ['#3d90ba'],
            borderColor: ['#3d90ba'],
            borderWidth: 1,
            hoverOffset: 4,
            barThickness: 30,
          },
          {
            data: data3,
            label: t('dashboard.chartLegend.emission') /* LAP-733 (GE022) */,
            backgroundColor: ['red'],
            borderColor: ['red'],
            borderWidth: 1,
            hoverOffset: 4,
            barThickness: 30,
          },
        ],
      })
  }, [reports])

  return (
    <>
      {reports && data.labels.length === 0 && data.datasets[0].data.length === 0 ? (
        <WTypography variant="h6" align="center" marginTop="10rem">
          {t('dashboard.noData') /* LAP-733 (GE022) */}
        </WTypography>
      ) : (
        <Bar data={data} height={'280%'} options={optionsbar} />
      )}
    </>
  )
}

export default HorizentalBarChart
